import React from 'react';
import styled from 'styled-components';
import {Tag} from 'antd';
import * as AppActions from '../../../AppActions';
import constants from '../../../constants';

function ProductItem(props) {
  const {product} = props;

  if (!product) {
    return <Wrapper css="height: 0px" />;
  }

  const image =
    (Array.isArray(product.images) &&
      product.images.length > 0 &&
      product.images[0].expected_url) ||
    '/images/empty-img.png';
  const labels =
    (Array.isArray(product.labels) &&
      product.labels.length > 0 &&
      product.labels) ||
    [];

  return (
    <Wrapper
      onClick={() => {
        AppActions.navigate(`/creator/${product.creator.path}/${product.id}`);
      }}>
      <img alt="product-img" src={image} />
      <div>
        <div className="labels">
          {labels
            .filter((label) => label.indexOf('創作者') === -1)
            .map((label, index) => (
              <Tag
                key={`product-lable-${index}`}
                color={constants.LABEL_COLORS[label]}>
                {label}
              </Tag>
            ))}
        </div>

        <div className="info">
          <h3>
            <span className="creator-name">
              {labels
                .filter((label) => label.indexOf('創作者') > -1)
                .map((label) => label.slice(4))}
            </span>
            {product.name}
          </h3>

          <h3>
            NT.{product.price}
            {!!(product.original_price && product.original_price > 0) && (
              <span className="original-price">
                NT.{product.original_price}
              </span>
            )}
          </h3>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  cursor: pointer;
  width: 270px;

  & > img {
    margin-bottom: 15px;
    background-color: #ffffff;
    width: 100%;
    height: 270px;
  }

  & > div {
    & > .labels {
      margin-bottom: 10px;
    }

    & > .info {
      & > h3 {
        margin-bottom: 40px;
        font-size: 1.2rem;
        color: var(--primaryColor);
      }

      & > h3 > span.creator-name {
        margin-bottom: 5px;
        display: block;
        font-size: 0.85rem;
        font-weight: 500;
        color: #4f4f4f;
      }

      & > h3 > span.original-price {
        margin-left: 5px;
        text-decoration: line-through;
        font-size: 0.85rem;
        color: #000000;
      }
    }
  }

  // 4 items in a row
  @media screen and (max-width: 1160px) {
    width: 230px;
    & > img {
      height: 230px;
    }
  }

  @media screen and (max-width: 1000px) {
    width: 210px;
    & > img {
      height: 210px;
    }
  }

  @media screen and (max-width: 920px) {
    width: 180px;
    & > img {
      height: 180px;
    }
  }

  @media screen and (max-width: 800px) {
    width: 160px;
    & > img {
      height: 160px;
    }
  }

  @media screen and (max-width: 550px) {
    width: 200px;
    & > img {
      height: 200px;
    }
  }

  ${(props) => props.css || ''}
`;

export default ProductItem;
